<template>
  <div class="modal" :class="{show}" @click="dismiss">
    <div class="modalContainer" @click="grabClick">
      <div class="title">
        {{ title }}
      </div>
      <slot class="body"></slot>
      <div class="footer" :class="{single: actions.length === 1}">
        <button
          :id="action.id"
          class="btn"
          :class="[(action.primary ? 'btn-primary' : 'btn-secondary')]"
          v-for="action of actions"
          :key="action.name"
          @click="callAction(action.action)">
          {{ action.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

  import { ModalEventBus } from "./ModalEventBus";

  export default {

    name: "Modal",

    props: ["name", "title", "actions", "dismissable"],

    data() {
      return {
        show: false
      }
    },

    beforeMount() {
      ModalEventBus.$on("toggle", this.handleToggle);
    },

    beforeDestroy() {
      ModalEventBus.$off("toggle", this.handleToggle);
    },

    methods: {
      handleToggle(name, state, data) {
        if (name !== this.name) {
          return;
        }
        if (typeof state == "undefined") {
          this.show = !this.show;
        } else {
          this.show = state;
        }
      },
      callAction(action) {
        if (typeof action == "string") {
          if (action === "close") {
            this.show = false;
          }
        } else if (typeof action == "function") {
          action();
        }
      },
      dismiss() {
        if (typeof this.dismissable != "undefined") {
          this.show = false;
        }
      },
      grabClick(e) {
        e.stopPropagation();
      }
    }

  };

</script>

<style lang="scss" scoped>

  .modal {
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    z-index: 11;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    &.show {
      opacity: 1;
      pointer-events: all;
      .modalContainer {
        top: 0;
      }
    }
  }
  .modalContainer {
    padding: 30px 40px;
    margin: 15px;
    background-color: white;
    max-width: 100%;
    border-radius: 2px;
    position: relative;
    top: -40px;
    transition: top 0.3s ease;

    & > div:not(.title, .footer) {
        max-height: 80vh;
        overflow-y: auto;
    }
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 30px;
    padding-bottom: 4px;
  }
  .footer {
    margin: 30px -5px -5px -5px;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    .btn:not(:first-of-type) {
      margin-left: 20px;
    }
    &.single {
      justify-content: center;
    }
    .btn-secondary {
      background-color: #f5f5f5;
    }
  }

</style>
